<script setup lang="ts">
  import { usePostDialog } from '@/hooks/usePostDialog'
  import AppPostChallenge from '@/components/AppPostChallenge/AppPostChallenge.vue'

  defineOptions({ name: 'AppPostDialog' })

  const { state, hidePostDialog } = usePostDialog()

  const handleClose = () => {
    hidePostDialog()
  }
</script>

<template>
  <AppPostChallenge
    v-if="state.visible && state.config"
    v-bind="state.config"
    @close="handleClose"
  />
</template>
